import Cookies from "./cookies";
import LANG from "../i18n/loader";

const Tools = new class {
  getPrefix() {
    const paths = window.location.pathname.split("/");
    if(paths.length < 2 || paths[1].length === 0) return "";
    return "/" + paths[1];
 }

  updateURL(url) {
    window.location = this.getPrefix() + url;
  }

  isValueLocked(val){
    return !val || val === NaN || val === 'l';
  }

  prettifiyShareName(shareName) {
    let specialFree = shareName.toLowerCase().replace(/\u00e4/g, 'ae').replace(/\u00f6/g, 'oe').replace(/\u00fc/g, 'ue').replace(/\u00df/g, 'ss').replace('-', '');
    let prettified = specialFree.replace(/-/g, '').replace(/ /g, '-').replace(/([^a-zA-Z0-9-])/g, '').replace(/--/g, '-');
    return prettified;
  }

  prettyInfoName(name) {
    let prettifiedName = name.replace(/_/g, ' ').replace(/(^.|\s.)/g, x => x.toUpperCase())
    return prettifiedName;
  }

  latestShare(share, item, string = false, point = false) {
    if (share.length === 0) {
      return '';
    }
    let latest = share[share.length - 1]
    let value = latest[item];
    let dimension = latest.dimension;
    let currency = latest.currency;

    if (string) {
      if (point) {
        return this.locale(value);
      }
      return value;
    }

    if (dimension === 'MIO') {
      value *= Math.pow(10, 6);
    }
    return this.locale(value) + ' ' + currency;
  }

  percentage(value, precision) {
    return this.round(value * 100, precision);
  }

  round(value, precision) {
    if (precision === undefined) { precision = 0; }
    return Math.round(value * Math.pow(10, precision)) / Math.pow(10, precision);
  }

  locale(x) {
    if (!isNaN(parseFloat(x))) {
      return parseFloat(x).toLocaleString(Cookies.get('language'));
    }
    return x;
  }

  localeFixed(x, fixed) {
    if (!isNaN(parseFloat(x))) {
      return parseFloat(x).toLocaleString(Cookies.get('language'), {minimumFractionDigits: fixed});
    }
    return x;
  }

  localeAmount(x) {
    if (x > 999999999999) {
      var trio = x / 1000000000000;
      return `${this.localeRound(trio, 2)}${LANG.detail.general.trillion}`;
    }
    else if (x > 999999999) {
      var bio = x / 1000000000;
      return `${this.localeRound(bio, 2)}${LANG.detail.general.billion}`;
    }
    else if (x > 999999) {
      var mio = x / 1000000;
      return `${this.localeRound(mio, 2)}${LANG.detail.general.million}`;
    }
    else {
      return this.locale(x);
    }
  }

  localePercentage(x, precision) {
    return this.locale(this.percentage(x, precision));
  }

  localeRound(x, precision) {
    return this.locale(this.round(x, precision));
  }

  localePercentageFixed(x, precision, fixed) {
    if (fixed)
      return this.localeFixed(this.percentage(x, precision), fixed);
    else
      return this.locale(this.percentage(x, precision));
  }

  localeRoundFixed(x, precision, fixed) {
    if (fixed)
      return this.localeFixed(this.round(x, precision), fixed);
    else
      return this.locale(this.round(x, precision));

  }

  currentDatestring() {
    const date = new Date();
    const full_year = date.getFullYear();
    const month = date.getMonth() + 1;
    const full_month = month < 10 ? `0${month}` : month;
    const day = date.getDate();
    const full_day = day < 10 ? `0${day}` : day;
    const datestring = full_year + "-" + full_month + "-" + full_day;
    return datestring;
  }

  localeDatetime(date) {
    const options = { day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' };
    return this.__localeDate(date, options);
  }

  localeDateTimeShort(date) {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' };
    return this.__localeDate(date, options);
  }

  localeDate(date) {
    const options = { day: '2-digit', month: 'long', year: 'numeric' };
    return this.__localeDate(date, options);
  }

  localeDateMedium(date) {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return this.__localeDate(date, options);
  }

  localeDateShort(date) {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    return this.__localeDate(date, options);
  }

  localeDateForGraph(date) {
    const options = { day: '2-digit', month: 'short', year: '2-digit' };
    return this.__localeDate(date, options);
  }

  localeDateMonthYear(date) {
    const options = { month: 'short', year: '2-digit' };
    return this.__localeDate(date, options);
  }

  __localeDate(date, options) {
    let datestring = date;
    if (typeof date === 'string') {
      if (date.includes(' ')) {
        datestring = date.replace(' ', 'T');
      }
    }
    const event = new Date(datestring);
    return event.toLocaleDateString(Cookies.get('language'), options);
  }

  dateToTimestamp(string) {
    if (typeof string === "number") { return string; }
    const event = new Date(string) / 1000;
    return event;
  }

  timestampFromMidnight() {
    return (new Date().setHours(0, 0, 0, 0)) / 1000
  }

  shortText(text, length = 50, appendDots = true) {
    if (!text) return null;
    return text.length > length ? text.substr(0, length) + (appendDots === true ? '...' : '') : text;
  }

}();

export default Tools;